import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {PreferencesComponent} from './preferences.component';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {DiscardChangesPromptComponent} from '../discard-changes-prompt/discard-changes-prompt.component';

@Injectable()
export class PreferencesDeactivationGuard implements CanDeactivate<PreferencesComponent> {
    private readonly matDialog: MatDialog;

    constructor(matDialog: MatDialog) {
        this.matDialog = matDialog;
    }

    canDeactivate(component: PreferencesComponent, currentRoute: ActivatedRouteSnapshot,
                        currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (component.shouldStopFromNavigatingAway()) {
            return this.matDialog.open<DiscardChangesPromptComponent, boolean>(DiscardChangesPromptComponent).afterClosed();
        } else {
            return true;
        }
    }
}
